import { currentSeasonLabel } from '@houseops/shared';

/**
 * Season + year stamp. Renders like a printed "issue date" on a
 * field-binder cover — small, mono, all caps, kerned.
 *
 * The wider letter-spacing and the leading dot ornament are the
 * single subtle "house style" gesture every page inherits.
 */
export function SeasonBadge() {
  return (
    <span className="inline-flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.22em] text-muted-foreground">
      <span aria-hidden className="h-1.5 w-1.5 rounded-full bg-primary/60" />
      {currentSeasonLabel()}
    </span>
  );
}
